import { Platform } from '@ionic/angular';

export const checkMobileDeviceSizeFunction = (platform: Platform): boolean =>
  platform.width() < 500 ? true : false;
